import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Reporting() {
    return (
        <OnboardingBody title='Reporting on where your best leads come from'>
            <p>
                The <strong>Attribution report</strong> can help identify which channels are
                bringing in the most leads (and which aren’t doing as well).
            </p>
        </OnboardingBody>
    );
}
